/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';
import FormControl from '@material-ui/core/FormControl';
import { useDispatch } from 'react-redux';
import format from 'date-fns/format';
import classNames from 'classnames';
import { subDays } from 'date-fns';
import moment from 'moment';
import { PlainString, keyEmptyCheck, getAmountInWords, formatCurrencyWithoutCurrency } from 'aurora-utils/utils';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { injectIntl } from 'react-intl';
import { mortgageBankMakerFormKeys as formKeys, CommaSeparatedWithoutCurrency } from 'aurora-utils/constants';
import messages from 'aurora-translations';
import Tooltip from '@material-ui/core/Tooltip';
import { ADGMDatePicker, ADGMTextField, ADGMSelect, ADGMPanel, ADGMCalenderField } from 'aurora-components';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';

import isEmpty from 'lodash/isEmpty';
import styles from './styles';

const MortgageDetails = props => {
  const { classes, mortgageDetails, bankDetails, isEditable } = props;

  if (!isEditable && (!isObject(mortgageDetails) || isEmpty(mortgageDetails) || !mortgageDetails?.mortgageAmount))
    return null;

  if (isEditable) {
    return <EditableMortgageDetails {...props} />;
  }
  return <NonEditableMortgageDetails classes={classes} mortgageDetails={mortgageDetails} bankDetails={bankDetails} />;
};

const NonEditableMortgageDetails = ({ classes, mortgageDetails, bankDetails }) => {
  const lang = localStorage.getItem('lang');

  const mortgageData = useMemo(() => {
    return {
      ...(mortgageDetails?.mortgageAmount && {
        mortgage_amount: formatCurrencyWithoutCurrency(mortgageDetails?.mortgageAmount),
        mortgage_amount_words: getAmountInWords(mortgageDetails.mortgageAmount, lang),
      }),
      // ...((mortgageDetails?.mortgageTypeNameE || mortgageDetails?.mortgageTypeNameA) && {
      //   mortgage_type:
      //     lang === "en" ? mortgageDetails?.mortgageTypeNameE : mortgageDetails?.mortgageTypeNameA,
      // }),
      ...(moment(mortgageDetails?.startDate).isValid() && {
        mortgage_start_date: moment(mortgageDetails?.startDate).format('DD/MM/YYYY'),
      }),
      ...(moment(mortgageDetails?.endDate).isValid() && {
        mortgage_end_date: moment(mortgageDetails?.endDate).format('DD/MM/YYYY'),
      }),
      ...((mortgageDetails?.mortgageTypeNameE || mortgageDetails?.mortgageTypeNameA) && {
        mortgage_type: lang === 'en' ? mortgageDetails?.mortgageTypeNameE : mortgageDetails?.mortgageTypeNameA,
      }),
      // ...((mortgageDetails?.valuatorNameE || mortgageDetails?.valuatorNameA) && {
      //   mortgage_type:
      //     lang === "en" ? mortgageDetails?.valuatorNameE : mortgageDetails?.valuatorNameA,
      // }),
      // ...((mortgageDetails?.nameEn || mortgageDetails?.nameAr) && {
      //   mortgage_type:
      //     lang === "en" ? mortgageDetails?.nameEn : mortgageDetails?.nameAr,
      // }),
      ...(mortgageDetails?.contractNumber && {
        contract_number: mortgageDetails?.contractNumber,
      }),
      ...((mortgageDetails?.bankSignatoryNameE || mortgageDetails?.bankSignatoryNameA) && {
        bank_signatory: lang === 'en' ? mortgageDetails?.bankSignatoryNameE : mortgageDetails?.bankSignatoryNameA,
      }),
      // ...((mortgageDetails?.bankSignatoryNameE ||
      //   mortgageDetails?.bankSignatoryNameA) && {
      //     bank_signatory:
      //     lang === "en"
      //       ? mortgageDetails?.bankSignatoryNameE
      //       : mortgageDetails?.bankSignatoryNameA,
      // }),
      ...((mortgageDetails?.valuationCompanyNameE || mortgageDetails?.valuationCompanyNameA) && {
        valuation_company:
          lang === 'en' ? mortgageDetails?.valuationCompanyNameE : mortgageDetails?.valuationCompanyNameA,
      }),

      ...((mortgageDetails?.valuatorNameE || mortgageDetails?.valuatorNameA) && {
        valuator: lang === 'en' ? mortgageDetails?.valuatorNameE : mortgageDetails?.valuatorNameA,
      }),

      // ...((mortgageDetails?.userNameE || mortgageDetails?.userNameA) && {
      //   valuator:
      //     lang === "en"
      //       ? mortgageDetails?.userNameE
      //       : mortgageDetails?.userNameA,
      // }),
    };
  }, [mortgageDetails]);

  if (isEmpty(mortgageData)) return null;

  const details = {
    mortgage_bank: lang === 'en' ? bankDetails?.nameEn : bankDetails?.nameAr,
    ...mortgageData,
  };

  return (
    <ADGMPanel title={keyEmptyCheck('MORTGAGE_AGREEMENT')}>
      <div className={classes.container}>
        <Grid container>
          {isObject(details) &&
            Object.keys(details)?.map(key => (
              <Grid item xs={12} sm={6} md={3} className={classes.marginTop}>
                <ADGMItemDetails key={key} label={key} value={details[key]} />
              </Grid>
            ))}
        </Grid>
      </div>
    </ADGMPanel>
  );
};

const EditableMortgageDetails = props => {
  const {
    classes,
    intl,
    mortgageDetails,
    setMortgageDetails,
    // mortgageTypeError,
    mortgageTypesList,
    bankSignatoriesList,
    valuationCompaniesList,
    valuatorsList,
    fetchMortgageValuators,
    clearMortgageValuators,
    setMortgageTypeError,
    calculateFeeHandler,
    disableCalculateFeeButton,
    disableMortgageType,
    PropertyDetails,
    isMortgage,
    hideTopInforBar,
  } = props;
  const { mortgages, leaseHoldContracts } = PropertyDetails;
  const leaseHoldContract = leaseHoldContracts?.[0];
  const [inputWidth, setInputWidth] = useState(0);
  const inputRef = useRef(null);
  const lang = localStorage.getItem('lang');

  // eslint-disable-next-line no-unused-vars
  const LightTooltip = useMemo(
    () =>
      withStyles(theme => ({
        tooltip: {
          width: 'auto',
          maxWidth: inputWidth ? `${inputWidth}px` : 'auto',
          backgroundColor: theme.palette.primary.grey,
          color: theme.palette.primary.adgmBlack,
          boxShadow: '1px 2px 6px rgba(0, 0, 0, 0.3)',
          fontSize: '12px',
          lineHeight: '18px',
          borderRadius: '4px',
          fontWeight: '400',
          padding: '12px',
          marginTop: '5px',
        },
      }))(Tooltip),
    [inputRef.current],
  );

  useEffect(() => {
    setInputWidth(inputRef?.current ? inputRef?.current?.offsetWidth : 0);
  }, [inputRef?.current]);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setInputWidth(inputRef?.current ? inputRef?.current?.offsetWidth : 0);
    });
    return () => {
      window.removeEventListener('resize', () => setInputWidth(inputRef?.current ? inputRef?.current?.offsetWidth : 0));
    };
  }, []);

  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const contractStartDate = startDate => {
    if (startDate) {
      return new Date(startDate);
    }
  };
  const contractEndDate = endDate => {
    if (endDate) {
      if (isMortgage) return new Date(endDate);
      return subDays(new Date(endDate), 1);
    }
  };
  const handleInputChange = (key, data) => {
    if (key === 'valuatorCompanyId') {
      dispatch(setMortgageDetails({ key: 'valuatorUserId', value: '' }));
    }
    const value = isObject(data) ? data.value : data;
    if (key === formKeys?.valuationCompany && value && value !== mortgageDetails?.id) {
      fetchMortgageValuators(value);
      dispatch(setMortgageDetails({ [formKeys?.valuator]: '' }));
    }
    if (key === formKeys?.valuationCompany && !value) {
      clearMortgageValuators();
    }
    if (key === formKeys?.type && mortgageDetails[key] !== value) {
      setMortgageTypeError(null);
    }
    if (key === formKeys?.startDate && (!value || moment(value).isSameOrAfter(mortgageDetails?.endDate))) {
      dispatch(setMortgageDetails({ key: 'endDate', value: '' }));
    }
    if (mortgageDetails[key] !== value) {
      if (key === formKeys?.amount) {
        dispatch(setMortgageDetails({ key, value: PlainString(data) }));
      } else {
        dispatch(setMortgageDetails({ key, value }));
      }
    }
  };
  return (
    <Box className={classes.paperCardFrame}>
      <div className={classes.titleHead}>
        <Typography variant='h6' component='h1' className={classes.title}>
          {keyEmptyCheck('MORTGAGE_DETAILS')}
        </Typography>
      </div>

      <div className={classes.innerCard}>
        <FormControl className={classes.formControl}>
          {!hideTopInforBar && mortgages?.filter(item => item?.isActive === true)?.length > 0 && (
            <div className={classes.informationBanner}>
              <div>
                {' '}
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <g clipPath='url(#clip0_11967_18917)'>
                    <path
                      d='M20 10C20 11.9778 19.4135 13.9112 18.3147 15.5557C17.2159 17.2002 15.6541 18.4819 13.8268 19.2388C11.9996 19.9957 9.98891 20.1937 8.0491 19.8079C6.10929 19.422 4.32746 18.4696 2.92894 17.0711C1.53041 15.6725 0.578004 13.8907 0.192152 11.9509C-0.193701 10.0111 0.00433286 8.00043 0.761209 6.17317C1.51809 4.3459 2.79981 2.78412 4.4443 1.6853C6.08879 0.58649 8.02219 0 10 0C12.6513 0.00286757 15.1932 1.05736 17.0679 2.9321C18.9426 4.80684 19.9971 7.34872 20 10ZM11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333H8.33334V10H10V15.8333H11.6667V10ZM10 4.16667C9.75278 4.16667 9.5111 4.23998 9.30554 4.37733C9.09998 4.51468 8.93976 4.70991 8.84515 4.93831C8.75055 5.16672 8.72579 5.41805 8.77402 5.66053C8.82225 5.90301 8.94131 6.12573 9.11612 6.30055C9.29094 6.47537 9.51367 6.59442 9.75614 6.64265C9.99862 6.69088 10.25 6.66613 10.4784 6.57152C10.7068 6.47691 10.902 6.31669 11.0393 6.11113C11.1767 5.90557 11.25 5.66389 11.25 5.41667C11.25 5.08515 11.1183 4.7672 10.8839 4.53278C10.6495 4.29836 10.3315 4.16667 10 4.16667Z'
                      fill='#0088FF'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_11967_18917'>
                      <rect width='20' height='20' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <Typography className={classes.infoBannerText}>
                  {keyEmptyCheck('this_property_has_an_existing_mortgage')}
                </Typography>
                <Typography className={classes.infoBannerText}>
                  {mortgages
                    ?.filter(item => item?.isActive === true)
                    ?.map(mortgage =>
                      lang === 'ar'
                        ? `${
                            !isNull(mortgage.mortgageDegree)
                              ? ' درجة الرهن التأميني" ' + mortgage.mortgageDegree
                              : 'الرهن الحيازي"'
                          } مع ${!isNull(mortgage.bankAr) ? mortgage.bankAr : '-'}`
                        : `${
                            !isNull(mortgage.mortgageDegree)
                              ? 'Insurance Degree ' + mortgage.mortgageDegree
                              : 'Possessory Mortgage'
                          } with ${!isNull(mortgage.bankEn) ? mortgage.bankEn : '-'}`,
                    )
                    .join(`${lang === 'ar' ? ' و ' : ' and '}`)}
                </Typography>
              </div>
            </div>
          )}
          <div className={classes.fullWidthField}>
            <div>
              <ADGMTextField
                type='text'
                className={classes.field}
                value={mortgageDetails?.mortgageAmount || ''}
                mask={createNumberMask(CommaSeparatedWithoutCurrency)}
                label={intl.formatMessage({ ...messages.mortgage_amount })}
                placeholder={intl.formatMessage({
                  ...messages.agreement_placeholder,
                })}
                startAdornment='AED'
                onChange={e => handleInputChange(formKeys.amount, e.target.value)}
                required
              />
            </div>
            <div className={classes.divider}>
              <svg width='100%' height='1' viewBox='0 0 1224 1' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <rect width='1224' height='1' fill='#DADEE7' />
              </svg>
            </div>
          </div>

          <div>
            <ADGMDatePicker
              onChange={date => handleInputChange('startDate', format(date, 'yyyy-MM-dd'))}
              required
              lowerLimit={contractStartDate(leaseHoldContract?.contractStartDate)}
              upperLimit={contractEndDate(leaseHoldContract?.contractEndDate)}
              date={
                moment(mortgageDetails?.startDate).isValid()
                  ? moment(mortgageDetails?.startDate).format('MM/DD/YYYY')
                  : ''
              }
              component={
                <ADGMCalenderField
                  value={
                    moment(mortgageDetails?.startDate).isValid()
                      ? moment(mortgageDetails?.startDate).format('DD/MM/YYYY')
                      : ''
                  }
                  name={formKeys.startDate}
                  placeholder={intl.formatMessage({ ...messages.DD_MM_YYYY })}
                  label={intl.formatMessage({
                    ...messages.mortgage_start_date,
                  })}
                  required
                  autoComplete='off'
                  // startAdornment={<ADGMImage name='Calendar.svg' alt='calendar' />}
                  upperLimit={moment().format('YYYY-MM-DD')}
                  mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                  handleInputChange={dates => {
                    handleInputChange('startDate', dates ? format(dates, 'yyyy-MM-dd') : null);
                  }}
                />
              }
            />
          </div>
          <div>
            <ADGMDatePicker
              onChange={date => handleInputChange('endDate', format(date, 'yyyy-MM-dd'))}
              required
              {...(moment(mortgageDetails?.startDate).isValid()
                ? {
                    lowerLimit: moment(mortgageDetails?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                  }
                : {})}
              upperLimit={contractEndDate(leaseHoldContract?.contractEndDate)}
              disabled={!mortgageDetails?.startDate || !moment(mortgageDetails?.startDate).isValid()}
              date={
                moment(mortgageDetails?.endDate).isValid() ? moment(mortgageDetails?.endDate).format('MM/DD/YYYY') : ''
              }
              component={
                <ADGMCalenderField
                  value={
                    moment(mortgageDetails?.endDate).isValid()
                      ? moment(mortgageDetails?.endDate).format('DD/MM/YYYY')
                      : ''
                  }
                  name={formKeys.endDate}
                  placeholder={intl.formatMessage({ ...messages.DD_MM_YYYY })}
                  label={intl.formatMessage({ ...messages.mortgage_end_date })}
                  required
                  autoComplete='off'
                  // startAdornment={<ADGMImage name='Calendar.svg' alt='calendar' />}
                  mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                  disabled={!mortgageDetails?.startDate || !moment(mortgageDetails?.startDate).isValid()}
                  {...(moment(mortgageDetails?.startDate).isValid()
                    ? {
                        lowerLimit: moment(mortgageDetails?.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                      }
                    : {})}
                  handleInputChange={dates => {
                    handleInputChange('endDate', dates ? format(dates, 'yyyy-MM-dd') : null);
                  }}
                />
              }
            />
          </div>
          <div>
            {mortgageTypesList?.length > 0 ? (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.mortgage_type })}
                required
                name={formKeys.type}
                value={mortgageDetails?.mortgageTypeId || ''}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                onChange={handleInputChange}
                options={mortgageTypesList}
                customClasses={{ select: classes.adgmSelect }}
                disabled={disableMortgageType}
              />
            ) : (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.mortgage_type })}
                required
                name={formKeys.type}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                disabled
              />
            )}
          </div>

          <div>
            <ADGMTextField
              type='text'
              value={mortgageDetails?.contractNumber || ''}
              label={intl.formatMessage({ ...messages.contract_number })}
              placeholder={intl.formatMessage({
                ...messages.agreement_placeholder,
              })}
              onChange={e => handleInputChange(formKeys.contractNumber, e.target.value)}
              required
            />
          </div>
          <div>
            {bankSignatoriesList?.length > 0 ? (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.bank_signatory })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                required
                name={formKeys.signatory}
                value={mortgageDetails?.bankSignatoryId || ''}
                onChange={handleInputChange}
                options={bankSignatoriesList}
                customClasses={{ select: classes.adgmSelect }}
              />
            ) : (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.bank_signatory })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                required
                name={formKeys.signatory}
                customClasses={{ select: classes.adgmSelect }}
                disabled
              />
            )}
          </div>
          <div>
            {valuationCompaniesList?.length > 0 ? (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.valuation_company })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                name={formKeys.valuationCompany}
                value={mortgageDetails?.valuatorCompanyId || ''}
                onChange={handleInputChange}
                options={valuationCompaniesList}
                customClasses={{ select: classes.adgmSelect }}
              />
            ) : (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.valuation_company })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                name={formKeys.valuationCompany}
                customClasses={{ select: classes.adgmSelect }}
                disabled
              />
            )}
          </div>

          <div>
            {valuatorsList?.length > 0 ? (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.valuator })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                name={formKeys.valuator}
                value={mortgageDetails?.valuatorUserId || ''}
                onChange={handleInputChange}
                options={valuatorsList}
                customClasses={{ select: classes.adgmSelect }}
                disabled={!mortgageDetails?.valuatorCompanyId}
                required
              />
            ) : (
              <ADGMSelect
                type='select'
                label={intl.formatMessage({ ...messages.valuator })}
                placeholder={intl.formatMessage({
                  ...messages.select_an_option,
                })}
                name={formKeys.valuator}
                customClasses={{ select: classes.adgmSelect }}
                disabled
              />
            )}
          </div>
          <div className={classes.calculateFeeButtonContainer}>
            <Button
              disabled={
                disableCalculateFeeButton || (mortgageDetails?.valuatorCompanyId && !mortgageDetails?.valuatorUserId)
              }
              onClick={calculateFeeHandler}
              className={classNames(classes.calculateFeeButton, {
                [classes.disabledCalculateFeeButton]:
                  disableCalculateFeeButton || (mortgageDetails?.valuatorCompanyId && !mortgageDetails?.valuatorUserId),
              })}
              startIcon={
                <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <g clipPath='url(#clip0_11825_30789)'>
                    <mask id='path-1-inside-1_11825_30789' fill='white'>
                      <path d='M8.00001 1.33339C8.88435 1.33629 9.75933 1.51455 10.5743 1.85785C11.3893 2.20115 12.1281 2.70267 12.748 3.33339H10V4.66673H13.4287C13.7569 4.66637 14.0716 4.53583 14.3037 4.30373C14.5358 4.07164 14.6663 3.75696 14.6667 3.42873V5.83856e-05H13.3333V2.05206C12.185 1.01796 10.7613 0.339162 9.23495 0.0979309C7.70856 -0.1433 6.14496 0.0633964 4.73368 0.692967C3.32241 1.32254 2.12404 2.34795 1.28384 3.64492C0.443639 4.94189 -0.00232278 6.45472 9.0982e-06 8.00006H1.33334C1.33528 6.23254 2.03829 4.53798 3.28811 3.28816C4.53793 2.03834 6.23249 1.33533 8.00001 1.33339Z' />
                    </mask>
                    <path
                      d='M8.00001 1.33339C8.88435 1.33629 9.75933 1.51455 10.5743 1.85785C11.3893 2.20115 12.1281 2.70267 12.748 3.33339H10V4.66673H13.4287C13.7569 4.66637 14.0716 4.53583 14.3037 4.30373C14.5358 4.07164 14.6663 3.75696 14.6667 3.42873V5.83856e-05H13.3333V2.05206C12.185 1.01796 10.7613 0.339162 9.23495 0.0979309C7.70856 -0.1433 6.14496 0.0633964 4.73368 0.692967C3.32241 1.32254 2.12404 2.34795 1.28384 3.64492C0.443639 4.94189 -0.00232278 6.45472 9.0982e-06 8.00006H1.33334C1.33528 6.23254 2.03829 4.53798 3.28811 3.28816C4.53793 2.03834 6.23249 1.33533 8.00001 1.33339Z'
                      fill='black'
                    />
                    <path
                      d='M8.00001 1.33339L8.07 -19.9998L8.02329 -20L7.97658 -19.9999L8.00001 1.33339ZM12.748 3.33339V24.6667H63.6265L27.9631 -11.6202L12.748 3.33339ZM10 3.33339V-17.9999H-11.3333V3.33339H10ZM10 4.66673H-11.3333V26.0001H10V4.66673ZM13.4287 4.66673V26.0001H13.4401L13.4516 26L13.4287 4.66673ZM14.6667 3.42873L36 3.45166L36 3.4402V3.42873H14.6667ZM14.6667 5.83856e-05H36V-21.3333H14.6667V5.83856e-05ZM13.3333 5.83856e-05V-21.3333H-7.99999V5.83856e-05H13.3333ZM13.3333 2.05206L-0.942318 17.905L34.6667 49.9711V2.05206H13.3333ZM9.0982e-06 8.00006L-21.3333 8.03225L-21.3012 29.3334H9.0982e-06V8.00006ZM1.33334 8.00006V29.3334H22.6433L22.6667 8.02349L1.33334 8.00006ZM7.93002 22.6666C5.9935 22.6603 4.07747 22.2699 2.29281 21.5182L18.8558 -17.8025C15.4412 -19.2408 11.7752 -19.9877 8.07 -19.9998L7.93002 22.6666ZM2.29281 21.5182C0.508144 20.7664 -1.10971 19.6682 -2.46711 18.287L27.9631 -11.6202C25.366 -14.2628 22.2705 -16.3641 18.8558 -17.8025L2.29281 21.5182ZM12.748 -17.9999H10V24.6667H12.748V-17.9999ZM-11.3333 3.33339V4.66673H31.3333V3.33339H-11.3333ZM10 26.0001H13.4287V-16.6666H10V26.0001ZM13.4516 26C19.4298 25.9936 25.1614 23.6159 29.3886 19.3887L-0.781261 -10.7812C2.98181 -14.5443 8.08397 -16.6609 13.4057 -16.6666L13.4516 26ZM29.3886 19.3887C33.6159 15.1614 35.9936 9.42988 36 3.45166L-6.66665 3.40579C-6.66092 -1.91597 -4.54433 -7.01814 -0.781261 -10.7812L29.3886 19.3887ZM36 3.42873V5.83856e-05H-6.66666V3.42873H36ZM14.6667 -21.3333H13.3333V21.3334H14.6667V-21.3333ZM-7.99999 5.83856e-05V2.05206H34.6667V5.83856e-05H-7.99999ZM27.609 -13.8009C23.3938 -17.5967 18.168 -20.0884 12.5651 -20.9739L5.90476 21.1697C3.35466 20.7667 0.976202 19.6327 -0.942318 17.905L27.609 -13.8009ZM12.5651 -20.9739C6.96225 -21.8594 1.22281 -21.1006 -3.95753 -18.7897L13.4249 20.1756C11.0671 21.2274 8.45486 21.5728 5.90476 21.1697L12.5651 -20.9739ZM-3.95753 -18.7897C-9.13787 -16.4787 -13.5367 -12.7148 -16.6208 -7.95404L19.1885 15.2439C17.7848 17.4107 15.7827 19.1238 13.4249 20.1756L-3.95753 -18.7897ZM-16.6208 -7.95404C-19.7049 -3.19329 -21.3419 2.35983 -21.3333 8.03225L21.3333 7.96787C21.3372 10.5496 20.5922 13.0771 19.1885 15.2439L-16.6208 -7.95404ZM9.0982e-06 29.3334H1.33334V-13.3333H9.0982e-06V29.3334ZM22.6667 8.02349C22.6624 11.9058 21.1183 15.6279 18.3731 18.3731L-11.7968 -11.7968C-17.0417 -6.55193 -19.9918 0.559285 -20 7.97663L22.6667 8.02349ZM18.3731 18.3731C15.6278 21.1183 11.9058 22.6624 8.02344 22.6667L7.97658 -19.9999C0.559233 -19.9918 -6.55198 -17.0416 -11.7968 -11.7968L18.3731 18.3731Z'
                      fill='#0088FF'
                      mask='url(#path-1-inside-1_11825_30789)'
                    />
                    <mask id='path-3-inside-2_11825_30789' fill='white'>
                      <path d='M14.6668 8C14.6687 9.32356 14.2761 10.6177 13.539 11.717C12.802 12.8163 11.7539 13.671 10.5288 14.1719C9.30369 14.6728 7.95706 14.7971 6.66094 14.529C5.36482 14.2609 4.17804 13.6125 3.25216 12.6667H6.00016V11.3333H2.5715C2.24327 11.3337 1.92858 11.4642 1.69649 11.6963C1.46439 11.9284 1.33385 12.2431 1.3335 12.5713V16H2.66683V13.948C3.81518 14.9821 5.23883 15.6609 6.76522 15.9021C8.29162 16.1434 9.85521 15.9367 11.2665 15.3071C12.6778 14.6775 13.8761 13.6521 14.7163 12.3551C15.5565 11.0582 16.0025 9.54533 16.0002 8H14.6668Z' />
                    </mask>
                    <path
                      d='M14.6668 8C14.6687 9.32356 14.2761 10.6177 13.539 11.717C12.802 12.8163 11.7539 13.671 10.5288 14.1719C9.30369 14.6728 7.95706 14.7971 6.66094 14.529C5.36482 14.2609 4.17804 13.6125 3.25216 12.6667H6.00016V11.3333H2.5715C2.24327 11.3337 1.92858 11.4642 1.69649 11.6963C1.46439 11.9284 1.33385 12.2431 1.3335 12.5713V16H2.66683V13.948C3.81518 14.9821 5.23883 15.6609 6.76522 15.9021C8.29162 16.1434 9.85521 15.9367 11.2665 15.3071C12.6778 14.6775 13.8761 13.6521 14.7163 12.3551C15.5565 11.0582 16.0025 9.54533 16.0002 8H14.6668Z'
                      fill='black'
                    />
                    <path
                      d='M14.6668 8V-13.3333H-6.69745L-6.66648 8.03092L14.6668 8ZM3.25216 12.6667V-8.66667H-47.4848L-11.9927 27.59L3.25216 12.6667ZM6.00016 12.6667V34H27.3335V12.6667H6.00016ZM6.00016 11.3333H27.3335V-10H6.00016V11.3333ZM2.5715 11.3333V-10H2.56003L2.54856 -9.99999L2.5715 11.3333ZM1.3335 12.5713L-19.9998 12.5484L-19.9998 12.5599V12.5713H1.3335ZM1.3335 16H-19.9998V37.3333H1.3335V16ZM2.66683 16V37.3333H24.0002V16H2.66683ZM2.66683 13.948L16.9425 -1.90497L-18.6665 -33.971V13.948H2.66683ZM16.0002 8L37.3335 7.96781L37.3013 -13.3333H16.0002V8ZM-6.66648 8.03092C-6.67071 5.11316 -5.80512 2.26035 -4.18027 -0.163129L31.2583 23.5971C34.3573 18.975 36.0082 13.534 36.0001 7.96908L-6.66648 8.03092ZM-4.18027 -0.163129C-2.55542 -2.58661 -0.245067 -4.47075 2.45571 -5.57491L18.6019 33.9187C23.753 31.8128 28.1594 28.2193 31.2583 23.5971L-4.18027 -0.163129ZM2.45571 -5.57491C5.15649 -6.67907 8.1251 -6.95314 10.9824 -6.36209L2.3395 35.42C7.78903 36.5473 13.4509 36.0246 18.6019 33.9187L2.45571 -5.57491ZM10.9824 -6.36209C13.8397 -5.77104 16.4559 -4.34172 18.497 -2.25668L-11.9927 27.59C-8.09985 31.5667 -3.11003 34.2928 2.3395 35.42L10.9824 -6.36209ZM3.25216 34H6.00016V-8.66667H3.25216V34ZM27.3335 12.6667V11.3333H-15.3332V12.6667H27.3335ZM6.00016 -10H2.5715V32.6667H6.00016V-10ZM2.54856 -9.99999C-3.42966 -9.99356 -9.1612 -7.61588 -13.3885 -3.38862L16.7814 26.7813C13.0184 30.5443 7.91619 32.6609 2.59444 32.6667L2.54856 -9.99999ZM-13.3885 -3.38862C-17.6157 0.838635 -19.9934 6.57017 -19.9998 12.5484L22.6668 12.5943C22.6611 17.916 20.5445 23.0182 16.7814 26.7813L-13.3885 -3.38862ZM-19.9998 12.5713V16H22.6668V12.5713H-19.9998ZM1.3335 37.3333H2.66683V-5.33333H1.3335V37.3333ZM24.0002 16V13.948H-18.6665V16H24.0002ZM-11.6088 29.801C-7.39361 33.5968 -2.16785 36.0885 3.43503 36.9739L10.0954 -5.16968C12.6455 -4.76666 15.024 -3.63261 16.9425 -1.90497L-11.6088 29.801ZM3.43503 36.9739C9.03792 37.8594 14.7774 37.1007 19.9577 34.7897L2.57527 -4.17557C4.93305 -5.22737 7.54531 -5.5727 10.0954 -5.16968L3.43503 36.9739ZM19.9577 34.7897C25.138 32.4788 29.5368 28.7148 32.621 23.9541L-3.18829 0.756183C-1.78459 -1.41063 0.21749 -3.12376 2.57527 -4.17557L19.9577 34.7897ZM32.621 23.9541C35.7051 19.1934 37.342 13.6402 37.3335 7.96781L-5.33315 8.03219C-5.33704 5.45044 -4.59198 2.92299 -3.18829 0.756183L32.621 23.9541ZM16.0002 -13.3333H14.6668V29.3333H16.0002V-13.3333Z'
                      fill='#0088FF'
                      mask='url(#path-3-inside-2_11825_30789)'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_11825_30789'>
                      <rect width='16' height='16' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              }
            >
              {keyEmptyCheck('calculate_fee')}
            </Button>
          </div>
        </FormControl>
      </div>
    </Box>
  );
};

MortgageDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  bankDetails: PropTypes.object.isRequired,
  mortgageDetails: PropTypes.object.isRequired,
  mortgageTypeError: PropTypes.string.isRequired,
  mortgageTypesList: PropTypes.array.isRequired,
  bankSignatoriesList: PropTypes.array.isRequired,
  valuationCompaniesList: PropTypes.array.isRequired,
  valuatorsList: PropTypes.array.isRequired,
  setMortgageDetails: PropTypes.func.isRequired,
  fetchMortgageValuators: PropTypes.func.isRequired,
  clearMortgageValuators: PropTypes.func.isRequired,
  setMortgageTypeError: PropTypes.func.isRequired,
  calculateFeeHandler: PropTypes.func.isRequired,
  disableCalculateFeeButton: PropTypes.bool.isRequired,
  isEditable: PropTypes.bool,
  disableMortgageType: PropTypes.bool,
  isMortgage: PropTypes.bool,
  hideTopInforBar: PropTypes.bool,
};

EditableMortgageDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  bankDetails: PropTypes.object.isRequired,
  mortgageDetails: PropTypes.object.isRequired,
  mortgageTypeError: PropTypes.string.isRequired,
  mortgageTypesList: PropTypes.array.isRequired,
  bankSignatoriesList: PropTypes.array.isRequired,
  valuationCompaniesList: PropTypes.array.isRequired,
  valuatorsList: PropTypes.array.isRequired,
  setMortgageDetails: PropTypes.func.isRequired,
  fetchMortgageValuators: PropTypes.func.isRequired,
  clearMortgageValuators: PropTypes.func.isRequired,
  setMortgageTypeError: PropTypes.func.isRequired,
  calculateFeeHandler: PropTypes.func.isRequired,
  disableCalculateFeeButton: PropTypes.bool.isRequired,
  disableMortgageType: PropTypes.bool.isRequired,
  PropertyDetails: PropTypes.object.isRequired,
  isMortgage: PropTypes.bool.isRequired,
  hideTopInforBar: PropTypes.bool.isRequired,
};

NonEditableMortgageDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  bankDetails: PropTypes.object.isRequired,
  mortgageDetails: PropTypes.object.isRequired,
};

MortgageDetails.defaultProps = {
  isEditable: false,
  disableMortgageType: false,
  isMortgage: false,
  hideTopInforBar: false,
};

export default withStyles(styles)(injectIntl(MortgageDetails));
